import React from "react";

const LOGO_SRC = "/brand/aequor-logo.png";

/**
 * Logo Aequor a color (sin filtros invert).
 * En fondos oscuros usa placa crema para conservar verde/oro.
 */
export default function BrandLogo({
  className = "h-10",
  onDark = false,
  alt = "Aequor Group",
  testid,
}) {
  const img = (
    <img
      src={LOGO_SRC}
      alt={alt}
      data-testid={testid}
      className={`${className} w-auto object-contain object-center`}
      style={{ filter: "none" }}
    />
  );

  if (!onDark) return img;

  return (
    <div
      className="inline-flex items-center justify-center rounded-sm bg-[#F7F3EB] px-2 py-1.5"
      style={{ boxShadow: "0 0 0 1px rgba(184,151,95,0.25)" }}
    >
      {img}
    </div>
  );
}
